// import styled from 'styled-components';
// export const Cstable = styled.div`
//   display: table;
//   border-collapse: collapse;
//   width: 100%;
//   .cscell {
//     display: table-cell;
//     padding: 5px;
//     border: 1px solid #d8d8d8;
//     color: #333;
//   }
//   &.tableFare .cscell:nth-child(1),
//   &.tableBrkUP .cscell:nth-child(1),
//   &.fareRulesTable .cscell:nth-child(1) {
//     width: 50%;
//   }
//   &.tableFare .cscell:nth-child(2) {
//     text-align: right;
//   }
//   &.tableFare .cscell {
//     padding: 10px;
//   }
//   &.baggage .cscell {
//     padding: 10px;
//   }
// `;
// export const Csrow = styled.div`
//   display: table-row;
//   .width30 {
//     width: 30%;
//   }
//   .width35 {
//     width: 35%;
//   }
// `;
// export const Cscell = styled.div`
//   display: table-cell;
//   padding: 5px;
//   border: 1px solid #d8d8d8;
// `;
// export const FareRulesTable = styled.div`
//   .frtable {
//     width: 47%;
//     float: left;
//     margin-bottom: 20px;
//   }
//   .frtable:nth-child(even) {
//     float: right;
//   }
//   .frcell {
//     padding: 10px;
//     width: 50%;
//   }
// `;

// export const TableFare = styled.div`
//   .cscell:nth-child(1),
//   .tableBrkUP .cscell:nth-child(1),
//   .fareRulesTable .cscell:nth-child(1) {
//     width: 50%;
//   }
//   .cscell {
//     padding: 10px;
//   }
// `;

// export const CancellationRules = styled.div`
//   .tableFare {
//     width: 47%;
//     float: left;
//     margin-bottom: 20px;
//   }
//   .tableFare:nth-child(even) {
//     float: right;
//   }
//   .cscell:nth-child(even) {
//     background-color: #fafafa;
//   }
// `;

// export const Refundability = styled.div(
//   props => `
//     ${
//       props.isRefundable
//         ? `background-image: linear-gradient(
//       76deg
//       , #00c57e, #18a160);`
//         : `background: #f00;`
//     }
//     border-radius: 2px;
//     text-transform: uppercase;
//     font-size: 1.1rem;
//     padding: 0.5rem;
//   `
// );

import styled, { css } from 'styled-components';
import CloseIcon from '../../../icons/Close';

export const Cstable = styled.div`
  display: table;
  border-collapse: collapse;
  width: 100%;
`;

export const Csrow = styled.div`
  display: table-row;
`;

export const Cscell = styled.div`
  display: table-cell;
  border: 1px solid #d8d8d8;
  background-color: ${props => (props.header ? '#F4F4F4' : 'unset')};
  padding: ${props => props.padding || '4px 8px'};
  vertical-align: top;
  ${props =>
    props.cp &&
    `
      &:first-child {
        width: 70%;
        color: #717171;
      }
      &:last-child {
        text-align: right;
      }
      ${
        props.header &&
        css`
          font-weight: 500;
          color: #222222;
          &:first-child {
            color: #222222;
          }
        `
      }
      font-size: ${props.header && !props.isDomRT ? '14px' : ''};
      &&.cancelBefore {
        color: #18a160;
      }
  `}
`;

export const Baggage = styled.div`
  margin-top: 25px;
`;

export const CloseIconRight = styled(CloseIcon)`
  position: absolute;
  right: 35px;
  top: 17px;
  cursor: pointer;
`;

export const ModalBodyWrapper = styled.div`
  max-height: 550px;
  overflow-y: auto;
  padding: 17px 35px;
`;

export const CancellationBlock = styled.div`
  width: ${props => (props.isDomRT ? '49%' : '45%')};
`;

export const CancellationWrap = styled.div`
  border-top: 2px solid #e1e7ee;
  padding: ${props => (props.isDomRT ? '15px 10px 0' : '15px 30px 0')};
  margin-top: 15px;
`;

export const PolicyWrap = styled.div`
  padding: 16px;
  border: 1px solid #e4e4e4;
  border-radius: 8px;
  margin-top: 10px;
  &:first-child {
    margin-top: 0;
  }
  ${props =>
    props.cnclPolicy &&
    css`
      padding: 12px 0 12px 0;
    `}
`;

export const CnclPolicySubHd = styled.div`
  padding: 0 10px;
`;

export const ImgWrapper = styled.div`
  gap: 0.5rem;
  display: flex;
`;

export const RefundTag = styled.span`
  display: flex;
  align-items: center;
  border-radius: 4px;
  padding: 4px 28px;
  ${props =>
    Array.isArray(props.bgColor) && props.bgColor.length === 1
      ? css`
          background: ${props.bgColor[0]};
        `
      : Array.isArray(props.bgColor) &&
        props.bgColor.length > 1 &&
        css`
          background-image: linear-gradient(90deg, ${props.bgColor.join(',')});
        `}
  color: ${props => props.fontColor || ''};
`;

export const ArrowWrap = styled.span`
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background-color: #e5f3ff;
  display: flex;
  align-items: center;
  justify-content: center;
  .downArw {
    transform: rotate(180deg);
  }
`;

export const PolicyBody = styled.div`
  padding: ${props => (props.isDomRT ? '20px 0' : '20px 24px 20px')};
`;
